import { render, staticRenderFns } from "./ManualPdf.vue?vue&type=template&id=218865fe&lang=pug&"
import script from "./ManualPdf.vue?vue&type=script&lang=ts&"
export * from "./ManualPdf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports